import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { getPlanPrice, getPlanDuration } from '../../layout-utils';
import { Attribute } from '../../attribute';
import { PlanDropdown } from '../plan-dropdown';
import './group-card.m.css';

export const GroupCard = ({
  group,
  selectedPlan,
  onSelect,
  selectedSubscriptions,
  setSelectedSubscriptions,
  activeDropdown,
  toggleDropdown,
  mode,
  localizedTime,
  showOfferPrice = false,
  cardRef,
  isSingleCard = false
}) => {
  const { name, subscription_plans: plans = [], id } = group;

  const initialPlan = plans[0] || {};
  const currentPlan = get(selectedSubscriptions, [id], initialPlan);
  const isGroupSelected = selectedPlan?.subscription_group_id === id || plans.some((p) => p.id === selectedPlan?.id);
  const isDropdownOpen = activeDropdown === id;

  const price = getPlanPrice(currentPlan?.price_currency, currentPlan?.price_cents);
  const duration = currentPlan ? getPlanDuration(localizedTime, currentPlan) : '';

  const hasDiscountAttrs = currentPlan?.custom_attributes?.some(
    (a) => (a.name === 'Actual Price' || a.name === 'Discount') && a.value
  );

  const handleCardClick = () => {
    onSelect(currentPlan);
  };

  const handleCardKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleCardClick();
    }
  };

  const handleSelectPlan = (plan) => {
    if (setSelectedSubscriptions) {
      setSelectedSubscriptions((prev) => ({ ...prev, [id]: plan }));
    }
    onSelect(plan);
    toggleDropdown(id);
  };

  const groupCardStyle = `group-card ${isSingleCard ? 'single-card' : ''} ${isGroupSelected ? 'selected' : ''} ${isDropdownOpen ? 'active-dropdown' : ''} ${mode === 'dark' ? 'dark' : ''}`.trim();
  const radioCircleStyle = `radio-circle ${isGroupSelected ? 'selected' : ''}`.trim();

  return (
    <div
      ref={cardRef}
      styleName={groupCardStyle}
      data-test-id={`loginless-subscription-grouped-plan-card-${id}`}
    >
      <button
        type="button"
        styleName="card-select-btn"
        aria-pressed={isGroupSelected}
        aria-label={`Select ${name} plan`}
        onClick={handleCardClick}
        onKeyDown={handleCardKeyDown}
      >
        <div styleName="card-top-row">
          <div styleName={radioCircleStyle} aria-hidden="true" data-test-id="subscription-plan-card-radio">
            {isGroupSelected && <div styleName="radio-inner" />}
          </div>
          <Attribute data={currentPlan} attributeName="Tag" />
        </div>

        <h3 styleName="group-name">{name}</h3>

        <div styleName="price-row">
          <span styleName="price-amount">{price}</span>
          <span styleName="price-duration">/ {duration}</span>
        </div>

        {showOfferPrice && (
          hasDiscountAttrs ? (
            <div styleName="discount-row">
              <Attribute data={currentPlan} attributeName="Actual Price" />
              <Attribute data={currentPlan} attributeName="Discount" />
            </div>
          ) : (
            <div styleName="discount-row placeholder" aria-hidden="true" />
          )
        )}
      </button>

      <PlanDropdown
        plans={plans}
        currentPlan={currentPlan}
        initialPlan={initialPlan}
        isOpen={isDropdownOpen}
        groupId={id}
        onToggle={toggleDropdown}
        onSelectPlan={handleSelectPlan}
        mode={mode}
      />
    </div>
  );
};

GroupCard.propTypes = {
  group: PropTypes.object.isRequired,
  selectedPlan: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  selectedSubscriptions: PropTypes.object,
  setSelectedSubscriptions: PropTypes.func,
  activeDropdown: PropTypes.string,
  toggleDropdown: PropTypes.func.isRequired,
  mode: PropTypes.string,
  localizedTime: PropTypes.string,
  showOfferPrice: PropTypes.bool,
  cardRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  isSingleCard: PropTypes.bool
};
